import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Title from 'evcharging/components/Title';
import Paragraph from 'evcharging/components/Paragraph';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import safeAndReliable from 'evcharging/assets/ev-charger/safeAndReliable.png';
import support from 'evcharging/assets/ev-charger/suport.png';
import Image from 'next/image';
import Spacer from 'evcharging/components/Spacer';
import useI18n from 'evcharging/hooks/useI18n';

const Support = () => {
  const { t } = useI18n();

  return (
    <Section>
      <Container>
        <Spacer value={0} mobile={10} />
        <Responsible fractions={[49, 49]} mobileReverse>
          <Image src={safeAndReliable} alt={t('charger.safe.alt')} width={522} height={399} />
          <Box maxWidth={510} display={'flex'} flexDirection={'column'} justifyContent={'center'}>
            <Spacer value={16} />
            <Title variant={'h2'}>{t('software.title4')}</Title>
            <Spacer value={16} />
            <Paragraph color={'middle'}>
              {t('software.text4')}
            </Paragraph>
          </Box>
        </Responsible>
        <Spacer value={150} mobile={32} />

        <Responsible fractions={[48, 49]}>
          <Box maxWidth={510}>
            <Spacer value={12} />
            <Title fontSize={34} variant={'h2'}>
              {t('software.title5')}
            </Title>
            <Spacer value={16} />
            <Paragraph color={'middle'}>
              {t('software.text5')}
            </Paragraph>
            <Spacer value={24} />
            <Paragraph color={'middle'}>
              {t('software.text6')}
            </Paragraph>
          </Box>
          <Image src={support} alt={t('charger.support.alt')} width={522} height={399} />
        </Responsible>
        <Spacer value={132} mobile={24} />
      </Container>
    </Section>
  );
};

export default Support;
